import type { AppDispatch } from "../../../../store"
import { instancesSlice } from "./instances-slice"
import { panelsSlice } from "./panels-slice"
import { coreSlice } from "./core-slice"
import { modelSlice } from "./model-slice"
import { tradeSlice } from "./trade-slice"
import { optimizationSlice } from "./optimization-slice"
import { assetViewSlice } from "./asset-view-slice"
import { factorsViewSlice } from "./factors-view-slice"
import { graphSlice } from "./graph-slice"
import { kpiSlice } from "./kpi-slice"

// Drops an instance's [dashboardId] entry from every dashboard-scoped slice — they have no unmount
// GC, so it would otherwise leak for the session. Panel slices (assetView/factorsView/graph/kpi)
// drop the whole dashboardId key, clearing the empty {} that per-panel removePanel leaves. Registry
// last; dashboardId == instanceId in the routed model.
export function removeInstanceFromStore(
  dispatch: AppDispatch,
  args: { instanceId: string, dashboardId: string },
): void {
  const { instanceId, dashboardId } = args

  // New dashboard-scoped slice? Add it here AND to seedAllSlices in remove-instance.test.ts. [APP-3309]
  // Flat per-dashboard slices.
  dispatch(panelsSlice.actions.removeInstance({ dashboardId }))
  dispatch(coreSlice.actions.removeInstance({ dashboardId }))
  dispatch(modelSlice.actions.removeInstance({ dashboardId }))
  dispatch(tradeSlice.actions.removeInstance({ dashboardId }))
  dispatch(optimizationSlice.actions.removeInstance({ dashboardId }))

  // Panel-scoped slices (dashboardId → panelId → state): drop the whole dashboardId key.
  dispatch(assetViewSlice.actions.removeInstance({ dashboardId }))
  dispatch(factorsViewSlice.actions.removeInstance({ dashboardId }))
  dispatch(graphSlice.actions.removeInstance({ dashboardId }))
  dispatch(kpiSlice.actions.removeInstance({ dashboardId }))

  // Registry row last.
  dispatch(instancesSlice.actions.removeInstance(instanceId))
}
